/* eslint-disable angular/no-private-call */

export const compileTemplateComponentModule = angular
  .module('Q.components.compile-template', [])

  /**
   * @docType shared
   * @category directive
   *
   * @ngdoc directive
   *
   * @name compileTemplate
   * @restrict EA
   * @scope
   * @priority 400
   *
   * @description
   * Compiles and injects a template, similar to ng-include, but works with templates stored in strings, rather than
   * asynchronous template loading.
   *
   * Note: Unlike ng-include, this directive is always synchronous, and therefore doesn't have an onload attribute,
   * doesn't autoscroll, and doesn't broadcast any events.
   *
   * @param {expression} compileTemplate|src Angular expression returning the template to compile and inject
   * @param {expression} scope Override scope source
   * @param {expression} scopeVars Add custom vars to the new scope
   *
   */
  .directive('compileTemplate', function ($compile, $animate) {
    return {
      restrict: 'EA',
      priority: 400,
      terminal: true,
      transclude: 'element',
      controller: angular.noop,
      compile: function (tElement, tAttr) {
        const srcExp = tAttr.compileTemplate || tAttr.src;

        return function (scope, el, attr, ctrl, $transclude) {
          let currentScope;
          let previousElement;
          let currentElement;

          const cleanupCurrentContent = function () {
            if (previousElement) {
              // in case we somehow get new content while the old content is still animating away
              previousElement.remove();
              previousElement = null;
            }
            if (currentScope) {
              currentScope.$destroy();
              currentScope = null;
            }
            if (currentElement) {
              $animate.leave(currentElement).done(function (response) {
                if (response !== false) previousElement = null;
              });
              previousElement = currentElement;
              currentElement = null;
            }
          };

          scope.$watch(srcExp, function compileTemplateWatchAction(template) {
            cleanupCurrentContent();

            // only render if the template is truthy, or any string (including '')
            if (template || angular.isString(template)) {
              if (scope.$$destroyed) return;
              ctrl.template = template;
              currentScope = (
                tAttr.scope ? scope.$eval(tAttr.scope) : scope
              ).$new();
              if (tAttr.scopeVars) {
                angular.extend(currentScope, scope.$eval(tAttr.scopeVars));
              }
              currentElement = $transclude(currentScope, function (clone) {
                $animate.enter(clone, null, el);
              });
            }
          });
        };
      },
    };
  })

  // This directive is called during the $transclude call of the first `ngInclude` directive.
  // It will replace and compile the content of the element with the loaded template.
  // We need this directive so that the element content is already filled when
  // the link function of another directive on the same element as ngInclude
  // is called.
  .directive('compileTemplate', function ($compile) {
    return {
      restrict: 'ECA',
      priority: -400,
      require: 'compileTemplate',
      link: function (scope, $element, $attr, ctrl) {
        // Copied from ngInclude, but we don't need it right now
        // if(toString.call($element[0]).match(/SVG/)) {
        // 	// WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
        // 	// support innerHTML, so detect this here and try to generate the contents
        // 	// specially.
        // 	$element.empty();
        // 	$compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
        // 		function namespaceAdaptedClone(clone) {
        // 			$element.append(clone);
        // 		}, { futureParentElement: $element });
        // 	return;
        // }

        $element.html(ctrl.template);
        $compile($element.contents())(scope);
      },
    };
  });
